<div mat-dialog-content [innerHTML]="data.message"></div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="confirm()">OK</button>
</div>
